import React from 'react'
import "./intro.css";
import bg from '../../assets/code4.png'
// import {Link} from 'react-scroll';
import btnImg from '../../assets/downloadLogo3.png'
import cv from '../../assets/GarvishJainResume.pdf'

const Intro = () => {
  return (
    <section id="intro">
        <div className="introContent">
            <span className="hello">Hello,</span>
            <span className="introText">I'm <span className="introName">Garvish</span> <br/>Software Developer</span>
            <p className="introPara">Skilled in designing APIs, managing databases, and implementing 
              <br/>robust solutions to optimize server performance.
              <br/> Dedicated to building efficient, scalable, and secure web applications.
            <br/> Seeking to contribute my experience in cloud services, microservices architecture,
            <br/> and RESTful API development to deliver high-quality backend solutions.</p>
            {/* <Link href="../../assets/GarvishJainResume.pdf" download="Garvish_CV.pdf"> */}
              <a href={cv} download="Garvish_CV.pdf">
              <button className="btn">
                <img src={btnImg} alt="Hire Me" className='btnImg'/>
                <p className='btnImgText'>CV</p>
              </button>
              </a>
            {/* </Link> */}
        </div>
        <img src={bg} alt="Profile" className="bg" />
    </section>
  )
}

export default Intro
